/*
 * @Author: 丨小小风离丨
 * @Date: 2024-01-24 11:13:42
 * @LastEditTime: 2025-04-10 15:18:00
 * @LastEditors: 丨小小风离丨
 * @FilePath: \web-school-enroll\src\page\materials\index.tsx
 * @Description: 学校招生查询
 */
import LabelNone from "@/components/label_none";
import { CommmonGet } from "@/util/network/api";
import { Spin } from "antd";
import { useEffect, useState } from "react";
import { Outlet, useLocation, useNavigate } from "react-router-dom";
import "./index.scss";
import { LgPaginationA } from "lancoo-web-ui";

const pageSizeList = [
    { text: "每页10条", Info: 10 },
    { text: "每页20条", Info: 20 },
    { text: "每页30条", Info: 30 },
];

const Materials = () => {
    const service = {
        list: "/portal/homepage/getmaterials",
        countViews: "/portal/homepage/countViews",
    };
    const { pathname, search } = useLocation();
    const navigate = useNavigate();

    // 刷新
    const [isloading, setIsloading] = useState<boolean>(false);
    const [onceload, setOnceload] = useState<boolean>(false);
    // 表格
    const [list, setList] = useState<any[]>([]);
    const [total, setTotal] = useState<number>(0);
    const [pageNum, setPageNum] = useState(1);
    const [pageSize, setPageSize] = useState(10);

    const getInit = (curPageNum = 1, curPageSize = 10) => {
        setIsloading(true);
        CommmonGet(service.list, {
            pageIndex: curPageNum,
            pageSize: curPageSize,
        })
            .then((res: any) => {
                setList(res.data?.pageList || []);
                setTotal(res.data.total);
            })
            .catch(() => { })
            .finally(() => {
                setIsloading(false);
                setOnceload(true);
            });
    };

    const handleIndex = (item) => {
        // 在跳转前设置标记
        sessionStorage.setItem('fromNavigate', 'true');
        navigate(`/materials/details?infoId=${item.infoId}`);
    };

    useEffect(() => {
        pathname === "/materials" && getInit(pageNum, pageSize);
    }, [pathname]);

    return (
        <>
            {pathname === "/materials" && (
                <div className="materials">
                    <Spin spinning={isloading} className="wjz_spin_div">
                        {onceload ? (
                            list?.length !== 0 ? (
                                <>
                                    {list.map((ele, index) => {
                                        return (
                                            <div
                                                className="lately-item"
                                                key={ele.infoId || index}
                                                onClick={() => handleIndex(ele)}
                                            >
                                                <div className="title1 left">
                                                    {ele.infoTitle}
                                                    {ele.top == 1 ? <i></i> : null}
                                                </div>
                                                <div
                                                    className="download_right"
                                                    style={{ color: "#999999" }}
                                                >
                                                    {ele.times || 0}次浏览
                                                </div>
                                            </div>
                                        );
                                    })}
                                    <div className="materials_pagination">
                                        {
                                            total > pageSizeList[0].Info && <LgPaginationA
                                                total={Math.ceil(total / pageSize)}
                                                size="normal"
                                                currentPage={pageNum}
                                                onChangePage={(v) => {
                                                    setPageNum(v);
                                                    getInit(v, pageSize);
                                                }}
                                                pageSizeList={pageSizeList}
                                                pageSizeIndex={0}
                                                pageSizeSelect={(v) => {
                                                    const index = v.Info;
                                                    setPageSize(index);
                                                    setPageNum(1);
                                                    getInit(1, index);
                                                }}
                                                pageSizePosition={"top"}
                                            ></LgPaginationA>
                                        }

                                    </div>
                                </>
                            ) : (
                                <LabelNone tips="暂无招生历史数据" search={false} />
                            )
                        ) : (
                            <div></div>
                        )}
                    </Spin>
                </div>
            )}
            <Outlet />
        </>
    );
};

export default Materials;
